// LocalStorage & MySQL Dual Synchronization Service for Café 9 Phước Hải
import { 
    apiGetReviews, 
    apiCreateReview, 
    apiDeleteReview, 
    apiGetAnnouncements, 
    apiCreateAnnouncement, 
    apiUpdateAnnouncement, 
    apiDeleteAnnouncement,
    apiVerifyAdminPin,
    apiChangeAdminPin,
    apiGetMenu,
    apiCreateMenuItem,
    apiUpdateMenuItem,
    apiDeleteMenuItem,
    apiGetGallery,
    apiCreateGalleryItem,
    apiUpdateGalleryItem,
    apiDeleteGalleryItem
} from './api';

const STORAGE_KEYS = {
    ANNOUNCEMENTS: 'cafe9_announcements_data',
    REVIEWS: 'cafe9_customer_reviews_data',
    MENU: 'cafe9_menu_items_data',
    GALLERY: 'cafe9_gallery_items_data',
    ADMIN_PIN: 'cafe9_admin_security_pin'
};

const DEFAULT_PIN = '1983';

// Seed Initial Menu Items
const INITIAL_MENU_ITEMS = [
    {
        id: 1,
        name: "Cà Phê Đen Phin",
        category: "traditional",
        price: "15.000đ",
        description: "Cà phê xay nguyên chất, pha phin truyền thống. Vị đắng thanh, thơm nồng quyến rũ.",
        flavorNote: "Đậm vị, nguyên bản",
        image: "/images/cafe9/cafeden.JPG",
        isBestSeller: true,
        isMustTry: false,
        customTag: "Từ 1983",
        displayOrder: 1,
        isAvailable: true
    },
    {
        id: 2,
        name: "Cà Phê Đen Đá",
        category: "traditional",
        price: "15.000đ",
        description: "Ly cà phê đen đậm đặc được làm lạnh sảng khoái, đánh thức tinh thần cho một ngày mới.",
        flavorNote: "Mát lạnh, sảng khoái",
        image: "/images/cafe9/cafe914.JPG",
        isBestSeller: false,
        isMustTry: false,
        customTag: "",
        displayOrder: 2,
        isAvailable: true
    },
    {
        id: 3,
        name: "Cà Phê Sữa Nóng",
        category: "traditional",
        price: "18.000đ",
        description: "Sự kết hợp hoàn hảo giữa cốt cà phê phin sánh đặc và sữa đặc ngọt ngào béo ngậy.",
        flavorNote: "Ngọt béo, ấm nồng",
        image: "/images/cafe9/cafe912.JPG",
        isBestSeller: false,
        isMustTry: true,
        customTag: "",
        displayOrder: 3,
        isAvailable: true
    },
    {
        id: 4,
        name: "Cà Phê Sữa Đá",
        category: "traditional",
        price: "18.000đ",
        description: "Món cà phê quốc dân pha từ phin nhôm truyền thống của Café 9, béo ngậy hài hoà, cực kỳ hút khách.",
        flavorNote: "Hài hoà, đậm đà",
        image: "/images/cafe9/cafe916.JPG",
        isBestSeller: true,
        isMustTry: false,
        customTag: "Bán Chạy",
        displayOrder: 4,
        isAvailable: true
    },
    {
        id: 5,
        name: "Bạc Xỉu Đá 3 Tầng",
        category: "specialty",
        price: "22.000đ",
        description: "Ba tầng sắc màu tinh tế từ sữa tươi, sữa đặc và lớp cà phê phin sánh mịn bên trên.",
        flavorNote: "Ngọt dịu, béo thơm",
        image: "/images/cafe9/cafe913.JPG",
        isBestSeller: false,
        isMustTry: true,
        customTag: "Khuyên Thử",
        displayOrder: 5,
        isAvailable: true
    },
    {
        id: 6,
        name: "Cà Phê Muối Đặc Trưng",
        category: "specialty",
        price: "25.000đ",
        description: "Lớp kem muối béo mặn nhẹ hoà quyện cùng cốt cà phê xay tạo nên hậu vị khó quên.",
        flavorNote: "Béo mặn, đậm đà",
        image: "/images/cafe9/cafe911.JPG",
        isBestSeller: true,
        isMustTry: false,
        customTag: "Món Mới",
        displayOrder: 6,
        isAvailable: true
    },
    {
        id: 7,
        name: "Ca Cao Sữa Đá",
        category: "tea_refresh",
        price: "20.000đ",
        description: "Bột ca cao nguyên chất thơm lừng pha cùng sữa tươi và đá lạnh giải khát tuyệt đỉnh.",
        flavorNote: "Đậm đà, ngọt ngào",
        image: "/images/cafe9/cafe915.JPG",
        isBestSeller: false,
        isMustTry: false,
        customTag: "",
        displayOrder: 7,
        isAvailable: true
    },
    {
        id: 8,
        name: "Trà Đào Cam Sả",
        category: "tea_refresh",
        price: "22.000đ",
        description: "Hương vị thanh mát từ trà đen ủ lạnh, miếng đào giòn ngọt kết hợp cam tươi và sả thơm ngát.",
        flavorNote: "Thanh nhiệt, thơm mát",
        image: "/images/cafe9/cafe917.JPG",
        isBestSeller: false,
        isMustTry: true,
        customTag: "",
        displayOrder: 8,
        isAvailable: true
    }
];

// Seed Initial Gallery Items
const INITIAL_GALLERY_ITEMS = [
    {
        id: 1,
        src: "/images/cafe9/2021_12_23_10_29_IMG_1807.JPG",
        category: "space",
        caption: "Không gian bình yên sớm mai tại Café 9 Phước Hải",
        displayOrder: 1
    },
    {
        id: 2,
        src: "/images/cafe9/cafeden.JPG",
        category: "coffee",
        caption: "Ly cà phê phin đậm đà nguyên chất từ năm 1983",
        displayOrder: 2
    },
    {
        id: 3,
        src: "/images/cafe9/cafe912.JPG",
        category: "moments",
        caption: "Khoảnh khắc thong thả thưởng thức cà phê cùng bạn bè",
        displayOrder: 3
    },
    {
        id: 4,
        src: "/images/cafe9/cafe913.JPG",
        category: "space",
        caption: "Góc quán mộc mạc lưu giữ bao kỷ niệm qua hơn 40 năm",
        displayOrder: 4
    },
    {
        id: 5,
        src: "/images/cafe9/cafe914.JPG",
        category: "coffee",
        caption: "Từng giọt cà phê phin rơi chầm chậm đầy lắng đọng",
        displayOrder: 5
    },
    {
        id: 6,
        src: "/images/cafe9/cafe916.JPG",
        category: "moments",
        caption: "Nét văn hoá cà phê sáng quen thuộc của người Phước Hải",
        displayOrder: 6
    }
];

// Seed Initial Announcements
const INITIAL_ANNOUNCEMENTS = [
    {
        id: 'ann_1',
        title: 'Café 9 Phục Vụ Xuyên Suốt Lễ & Tết – Mở Cửa Từ 04:30 Sáng',
        type: 'schedule',
        content: 'Café 9 luôn mở cửa từ 04h30 sáng mỗi ngày để đón bình minh làng chài Phước Hải cùng quý khách. Hân hạnh phục vụ cà phê phin xay thơm nồng!',
        displayType: 'banner',
        badgeText: 'Lịch Phục Vụ',
        linkText: 'Xem Menu & Vị Trí',
        linkUrl: '#menu',
        isActive: true,
        createdAt: '2026-08-22'
    },
    {
        id: 'ann_2',
        title: 'Ưu Đãi Cà Phê Xay Làm Quà Biếu',
        type: 'promo',
        content: 'Quý khách mua từ 1kg cà phê xay mang về được đóng gói phin quà tặng truyền thống Café 9.',
        displayType: 'banner',
        badgeText: 'Khuyến Mãi',
        linkText: 'Liên Hệ Đặt Ngay',
        linkUrl: '#contact',
        isActive: false,
        createdAt: '2026-08-20'
    }
];

// Seed Initial Reviews
const INITIAL_REVIEWS = [
    {
        id: 'rev_1',
        name: "Anh Minh Tuấn",
        role: "Du khách từ TP. Hồ Chí Minh",
        avatar: "T",
        stars: 5,
        favoriteDrink: "Cà Phê Đen Phin",
        comment: "Mỗi lần về Phước Hải nghỉ mát là sáng nào tôi cũng ghé Café 9 làm ly đen đá pha phin. Cà phê xay thơm nức mũi, đậm đà đúng chất xưa mà hiếm nơi nào ở phố còn giữ được!",
        date: "2026-08-15",
        isVerified: true
    },
    {
        id: 'rev_2',
        name: "Chị Thanh Nga",
        role: "Khách quen địa phương (Phước Hải)",
        avatar: "N",
        stars: 5,
        favoriteDrink: "Cà Phê Sữa Đá",
        comment: "Quán quen của gia đình tôi qua nhiều thế hệ. Cà phê phin ở đây giọt nào ra giọt nấy, sánh đậm tự nhiên, giá cả lại rất bình dân và gần gũi.",
        date: "2026-08-10",
        isVerified: true
    },
    {
        id: 'rev_3',
        name: "Anh Hoàng Nam",
        role: "Travel Blogger / Du khách",
        avatar: "H",
        stars: 5,
        favoriteDrink: "Bạc Xỉu Đá 3 Tầng",
        comment: "Quán mở từ 4h30 sáng cực kỳ tiện cho ai thích ngắm bình minh biển Phước Hải rồi ghé uống cà phê. Ly bạc xỉu 3 tầng béo thơm xuất sắc, không gian yên bình tuyệt vời.",
        date: "2026-08-02",
        isVerified: true
    },
    {
        id: 'rev_4',
        name: "Cô Mỹ Hạnh",
        role: "Khách du lịch Vũng Tàu",
        avatar: "M",
        stars: 5,
        favoriteDrink: "Cà Phê Sữa Nóng",
        comment: "Không gian mộc mạc đúng chất làng chài bình dị. Cà phê phin nóng hổi thơm phức xua tan đi cái lạnh sớm mai của gió biển. Rất đáng trải nghiệm!",
        date: "2026-07-28",
        isVerified: true
    }
];

// =========================================================================
// MENU ITEMS REPOSITORY
// =========================================================================

export const getMenuItems = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEYS.MENU);
        if (stored) {
            return JSON.parse(stored);
        }
        localStorage.setItem(STORAGE_KEYS.MENU, JSON.stringify(INITIAL_MENU_ITEMS));
        return INITIAL_MENU_ITEMS;
    } catch (e) {
        return INITIAL_MENU_ITEMS;
    }
};

export const saveMenuItems = (items) => {
    try {
        localStorage.setItem(STORAGE_KEYS.MENU, JSON.stringify(items));
        window.dispatchEvent(new Event('cafe9_menu_updated'));
    } catch (e) {
        console.error("Error saving menu items:", e);
    }
};

export const fetchMenuItemsAsync = async () => {
    try {
        const res = await apiGetMenu();
        if (res && res.status === 'success' && Array.isArray(res.data) && res.data.length > 0) {
            saveMenuItems(res.data);
            return res.data;
        }
    } catch (err) {
        console.log("MySQL API fallback fetch menu items:", err.message);
    }
    return getMenuItems();
};

export const createMenuItemAsync = async (menuData) => {
    try {
        const res = await apiCreateMenuItem(menuData);
        if (res && res.status === 'success') {
            const current = getMenuItems();
            const updated = [...current, res.data];
            saveMenuItems(updated);
            return res.data;
        }
    } catch (err) {
        console.log("MySQL API fallback create menu item:", err.message);
    }
    // Local fallback
    const current = getMenuItems();
    const newItem = {
        id: Date.now(),
        ...menuData,
        displayOrder: menuData.displayOrder || current.length + 1,
        isAvailable: menuData.isAvailable !== false
    };
    saveMenuItems([...current, newItem]);
    return newItem;
};

export const updateMenuItemAsync = async (menuData) => {
    try {
        await apiUpdateMenuItem(menuData);
    } catch (err) {
        console.log("MySQL API fallback update menu item:", err.message);
    }
    const current = getMenuItems();
    const updated = current.map(item => item.id === menuData.id ? { ...item, ...menuData } : item);
    saveMenuItems(updated);
};

export const deleteMenuItemAsync = async (id) => {
    try {
        await apiDeleteMenuItem(id);
    } catch (err) {
        console.log("MySQL API fallback delete menu item:", err.message);
    }
    const current = getMenuItems();
    const updated = current.filter(item => item.id !== id);
    saveMenuItems(updated);
};

// =========================================================================
// GALLERY ITEMS REPOSITORY
// =========================================================================

export const getGalleryItems = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEYS.GALLERY);
        if (stored) {
            return JSON.parse(stored);
        }
        localStorage.setItem(STORAGE_KEYS.GALLERY, JSON.stringify(INITIAL_GALLERY_ITEMS));
        return INITIAL_GALLERY_ITEMS;
    } catch (e) {
        return INITIAL_GALLERY_ITEMS;
    }
};

export const saveGalleryItems = (items) => {
    try {
        localStorage.setItem(STORAGE_KEYS.GALLERY, JSON.stringify(items));
        window.dispatchEvent(new Event('cafe9_gallery_updated'));
    } catch (e) {
        console.error("Error saving gallery items:", e);
    }
};

export const fetchGalleryItemsAsync = async () => {
    try {
        const res = await apiGetGallery();
        if (res && res.status === 'success' && Array.isArray(res.data) && res.data.length > 0) {
            saveGalleryItems(res.data);
            return res.data;
        }
    } catch (err) {
        console.log("MySQL API fallback fetch gallery items:", err.message);
    }
    return getGalleryItems();
};

export const createGalleryItemAsync = async (galleryData) => {
    try {
        const res = await apiCreateGalleryItem(galleryData);
        if (res && res.status === 'success') {
            const current = getGalleryItems();
            const updated = [res.data, ...current];
            saveGalleryItems(updated);
            return res.data;
        }
    } catch (err) {
        console.log("MySQL API fallback create gallery item:", err.message);
    }
    // Local fallback
    const current = getGalleryItems();
    const newItem = {
        id: Date.now(),
        ...galleryData,
        displayOrder: galleryData.displayOrder || current.length + 1
    };
    saveGalleryItems([newItem, ...current]);
    return newItem;
};

export const updateGalleryItemAsync = async (galleryData) => {
    try {
        await apiUpdateGalleryItem(galleryData);
    } catch (err) {
        console.log("MySQL API fallback update gallery item:", err.message);
    }
    const current = getGalleryItems();
    const updated = current.map(item => item.id === galleryData.id ? { ...item, ...galleryData } : item);
    saveGalleryItems(updated);
};

export const deleteGalleryItemAsync = async (id) => {
    try {
        await apiDeleteGalleryItem(id);
    } catch (err) {
        console.log("MySQL API fallback delete gallery item:", err.message);
    }
    const current = getGalleryItems();
    const updated = current.filter(item => item.id !== id);
    saveGalleryItems(updated);
};

// =========================================================================
// ANNOUNCEMENTS
// =========================================================================

export const getAnnouncements = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEYS.ANNOUNCEMENTS);
        if (stored) {
            return JSON.parse(stored);
        }
        localStorage.setItem(STORAGE_KEYS.ANNOUNCEMENTS, JSON.stringify(INITIAL_ANNOUNCEMENTS));
        return INITIAL_ANNOUNCEMENTS;
    } catch (e) {
        return INITIAL_ANNOUNCEMENTS;
    }
};

export const saveAnnouncements = (announcements) => {
    try {
        localStorage.setItem(STORAGE_KEYS.ANNOUNCEMENTS, JSON.stringify(announcements));
        window.dispatchEvent(new Event('cafe9_announcements_updated'));
    } catch (e) {
        console.error("Error saving announcements:", e);
    }
};

export const getActiveAnnouncements = () => {
    const list = getAnnouncements();
    return list.filter(item => item.isActive);
};

// Async MySQL API Integration for Announcements
export const fetchAnnouncementsAsync = async (onlyActive = false) => {
    try {
        const res = await apiGetAnnouncements(onlyActive);
        if (res && res.status === 'success' && Array.isArray(res.data)) {
            if (!onlyActive) {
                saveAnnouncements(res.data);
            }
            return res.data;
        }
    } catch (err) {
        console.log("MySQL API not reachable, using local storage fallback:", err.message);
    }
    return onlyActive ? getActiveAnnouncements() : getAnnouncements();
};

export const createAnnouncementAsync = async (annData) => {
    try {
        const res = await apiCreateAnnouncement(annData);
        if (res && res.status === 'success') {
            const current = getAnnouncements();
            const updated = [res.data, ...current.filter(i => i.id !== res.data.id)];
            saveAnnouncements(updated);
            return res.data;
        }
    } catch (err) {
        console.log("MySQL API fallback create announcement:", err.message);
    }
    // Local fallback
    const current = getAnnouncements();
    const newItem = {
        id: annData.id || 'ann_' + Date.now(),
        ...annData,
        createdAt: new Date().toISOString().split('T')[0]
    };
    saveAnnouncements([newItem, ...current]);
    return newItem;
};

export const updateAnnouncementAsync = async (annData) => {
    try {
        await apiUpdateAnnouncement(annData);
    } catch (err) {
        console.log("MySQL API fallback update announcement:", err.message);
    }
    const current = getAnnouncements();
    const updated = current.map(item => item.id === annData.id ? { ...item, ...annData } : item);
    saveAnnouncements(updated);
};

export const deleteAnnouncementAsync = async (id) => {
    try {
        await apiDeleteAnnouncement(id);
    } catch (err) {
        console.log("MySQL API fallback delete announcement:", err.message);
    }
    const current = getAnnouncements();
    const updated = current.filter(item => item.id !== id);
    saveAnnouncements(updated);
};

// =========================================================================
// REVIEWS
// =========================================================================

export const getReviews = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEYS.REVIEWS);
        if (stored) {
            return JSON.parse(stored);
        }
        localStorage.setItem(STORAGE_KEYS.REVIEWS, JSON.stringify(INITIAL_REVIEWS));
        return INITIAL_REVIEWS;
    } catch (e) {
        return INITIAL_REVIEWS;
    }
};

export const saveReviews = (reviews) => {
    try {
        localStorage.setItem(STORAGE_KEYS.REVIEWS, JSON.stringify(reviews));
        window.dispatchEvent(new Event('cafe9_reviews_updated'));
    } catch (e) {
        console.error("Error saving reviews:", e);
    }
};

// Async MySQL API Integration for Reviews
export const fetchReviewsAsync = async () => {
    try {
        const res = await apiGetReviews();
        if (res && res.status === 'success' && Array.isArray(res.data) && res.data.length > 0) {
            saveReviews(res.data);
            return res.data;
        }
    } catch (err) {
        console.log("MySQL API not reachable, using local storage fallback:", err.message);
    }
    return getReviews();
};

export const addReviewAsync = async (reviewData) => {
    try {
        const res = await apiCreateReview(reviewData);
        if (res && res.status === 'success') {
            const current = getReviews();
            const updated = [res.data, ...current];
            saveReviews(updated);
            return { status: 'success', data: res.data };
        }
        if (res && res.status === 'error') {
            return { status: 'error', message: res.message };
        }
    } catch (err) {
        if (err.response && err.response.data && err.response.data.message) {
            return { status: 'error', message: err.response.data.message };
        }
        console.log("MySQL API fallback create review:", err.message);
    }
    // Local fallback
    const reviews = getReviews();
    const newReview = {
        id: 'rev_' + Date.now(),
        name: reviewData.name.trim(),
        role: reviewData.role || 'Du khách',
        avatar: reviewData.name.trim().charAt(0).toUpperCase() || 'K',
        stars: Number(reviewData.stars) || 5,
        favoriteDrink: reviewData.favoriteDrink || 'Cà Phê Sữa Đá',
        comment: reviewData.comment.trim(),
        date: new Date().toISOString().split('T')[0],
        isVerified: true
    };
    saveReviews([newReview, ...reviews]);
    return { status: 'success', data: newReview };
};

export const deleteReviewAsync = async (id) => {
    try {
        await apiDeleteReview(id);
    } catch (err) {
        console.log("MySQL API fallback delete review:", err.message);
    }
    const current = getReviews();
    const updated = current.filter(r => r.id !== id);
    saveReviews(updated);
};

// =========================================================================
// ADMIN PIN
// =========================================================================

export const getAdminPin = () => {
    return localStorage.getItem(STORAGE_KEYS.ADMIN_PIN) || DEFAULT_PIN;
};

export const verifyAdminPin = (inputPin) => {
    const pin = getAdminPin();
    return inputPin.trim() === pin.trim();
};

export const verifyAdminPinAsync = async (inputPin) => {
    try {
        const res = await apiVerifyAdminPin(inputPin);
        if (res && res.status === 'success') {
            return true;
        }
    } catch (err) {
        console.log("MySQL API fallback verify PIN:", err.message);
    }
    return verifyAdminPin(inputPin);
};

export const setAdminPin = (newPin) => {
    localStorage.setItem(STORAGE_KEYS.ADMIN_PIN, newPin.trim());
};

export const changeAdminPinAsync = async (newPin) => {
    try {
        await apiChangeAdminPin(newPin);
    } catch (err) {
        console.log("MySQL API fallback change PIN:", err.message);
    }
    setAdminPin(newPin);
};
